import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "./baseUrl";
import { getAuthToken } from "./authSession";
import WorkStartPromptModal from "./WorkStartPromptModal";
import {
  dismissWorkStartPromptForToday,
  isWorkStartPromptDismissedToday,
} from "./workStartPrompt";
import { fetchAndCacheProfile } from "./visitorProfile";
import { useVisitorLanguage } from "./useVisitorLanguage";

const WorkStartPromptGate = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const lang = useVisitorLanguage();

  useEffect(() => {
    if (!getAuthToken()) {
      return;
    }

    if (isWorkStartPromptDismissedToday()) {
      return;
    }

    let cancelled = false;

    fetchAndCacheProfile(axios, baseUrl)
      .then((profile) => {
        if (cancelled) {
          return;
        }

        if (profile?.today_work_start_registered) {
          dismissWorkStartPromptForToday();
          return;
        }

        setVisible(true);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  const handleDismiss = () => {
    dismissWorkStartPromptForToday();
    setVisible(false);
  };

  const handleConfirm = () => {
    setVisible(false);
    navigate("/panel/profile", { state: { autoStartVisit: true } });
  };

  return (
    <WorkStartPromptModal
      lang={lang}
      visible={visible}
      onConfirm={handleConfirm}
      onDismiss={handleDismiss}
    />
  );
};

export default WorkStartPromptGate;
